import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from '@gemini/core';
export const Layout = () => {
    return _jsx(Box, { as: "main", children: "Layout" });
};
